import produce from "immer";
import { DEFAULT_ACTION, CASEDETAILS } from "./constants";

export const initialState = {
};

/* eslint-disable default-case, no-param-reassign */
const submittedCasesDetailsPageReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case DEFAULT_ACTION:
        break;
      case CASEDETAILS:
        draft.caseDetails = action.payload
        break;
      default:
        return state
    }
  });

export default submittedCasesDetailsPageReducer;
